import { createRef, useCallback, useEffect, useRef, useState } from "react";
import { PrestazioneRepository } from "core/data/index";
import { IDescrizioneAttivita, IGetPrestazioniRequest, IPrestazione } from "core/interfaces/data/IPrestazioneRequest";
import { CustomButton } from "core/interfaces/components/index";
import { Alert, ConfigProvider, Input, Button, List, Form, Spin } from "antd";
import "./PrestazioneSidebar.css";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import i18n from "utils/i18n";
import { setPrestazione, setTariffa } from "core/redux/features/dataForm/dataFormSlice";
import { IOption, IOptionDetail } from "core/interfaces/data/IOption";
import NavigationManager from "utils/NavigationManager";

import { FaChevronLeft, FaChevronRight, FaInfoCircle, FaSearch, FaTimesCircle } from "react-icons/fa";
import { modalListHeight } from "utils/Styles";
import { StorageHelper } from "utils/SessionStorageHelper";
import IPrestazioneProps from "../IPrestazioneProps";
import { Enhanced } from "utils/ReactUtils";
import CustomTranslation from "components/CustomTranslation/CustomTranslation";
import { INumericArrayRequest } from "core/interfaces/data/Base";
import CustomShelf from "components/CustomShelf/CustomShelf";

const PrestazioneSidebar: React.FC<IPrestazioneProps> = ({ dispatch, sessionInfo, t, dataForm }) => {
	const { MoveStep } = NavigationManager(sessionInfo);
	// const currentStep = getCurrentStep();
	const [prestazioni, setPrestazioni] = useState<IOption[]>([]);
	const [loading, setLoading] = useState<boolean>(true);

	const [macroPrestazioni, setMacroPrestazioni] = useState<IOption[]>([]);

	const chooseActivityRef: any = useRef(); // aggiunta $ALC
	const startRef: any = useRef(); // aggiunta $ALC
	const mainInputRef: any = useRef(); // aggiunta $ALC

	// roba nuova
	const [shelfOpen, setShelfOpen] = useState<boolean>(false); // aggiunta $ALC

	const [modalFilter, setModalFilter] = useState<string>();
	const [macroAttSelected, setMacroAttSelected] = useState<IOption | undefined>(undefined);
	const [prestazioneSelected, setPrestazioneSelected] = useState<IOption | undefined>(undefined);

	const [listaMacroFiltrata, setListaMacroFiltrata] = useState<IOption[]>([]);
	const [listaPrestazioniFiltrata, setListaPrestazioniFiltrata] = useState<IOption[]>([]);

	const [prestazioneNonErogabile, setPrestazioneNonErogabile] = useState<boolean>(false);
	const [loadingAttivitaQs, setLoadingAttivitaQs] = useState<boolean>(false);

	const descrizioneRef: any = createRef();
	const predescrizioneRef: any = createRef();

	const SetPrestazione = (prestazione: IPrestazione) => {
		dispatch(setPrestazione(prestazione));
		dispatch(setTariffa(undefined));
		MoveStep("next");
	};

	const getActivityOwner = useCallback((macroPrest: IOption[]) => {
		let actOwner = StorageHelper.getItem("activity-owner");
		return filtraLista(macroPrest, actOwner, null);
	}, []);

	const getDefaultActivity = useCallback((atts: IOptionDetail[]) => {
		let att = StorageHelper.getItem("default-activity");
		return filtraLista(atts, att, null);
	}, []);

	const filtraLista = (lista: any[], chiaveFiltro: string | null, chiaveMaster: string | null) => {
		let listaFilrata: any[] = [];
		if (chiaveFiltro) {
			listaFilrata = lista.filter((el: IOption) => el.key?.toString() === chiaveFiltro);
		} else if (chiaveMaster) {
			listaFilrata = lista.filter((el: IOptionDetail) => el.masterKey?.toString() === chiaveMaster);
		}
		return listaFilrata;
	};

	const OnSubmit = (data: any) => {
		if (prestazioneSelected) {
			let prestForm: IPrestazione = {
				Attivita: prestazioneSelected.label,
				IguAttivita: prestazioneSelected.key!,
			};
			SetPrestazione(prestForm);
		}
	};

	const openSelectionModal = () => {
		// setDivOpen("prestazione-modal");
		// setBackdropOpen("backdrop");
		setShelfOpen(true); //aggiunta $ALC

		document.body.classList.add("noscroll");
		chooseActivityRef.current.focus(); // aggiunta $ALC
	};
	const onClickModalClose = () => {
		closeModal();
		cleanModal();
		mainInputRef.current.focus(); // aggiunta $ALC
	};

	const selectMacroAtt = (macro: IOption) => {
		setLoading(true);
		setMacroAttSelected(macro);
		if (macro.key === -1) {
			setListaPrestazioniFiltrata(prestazioni);
		} else {
			let attFiltrate = filtraLista(prestazioni, null, macro.key!.toString());
			setListaPrestazioniFiltrata(attFiltrate);
		}
		setModalFilter("");
		setLoading(false);
	};

	const pressEnterSelectMacroAtt = (ev: any, macro: IOption) => {
		ev.preventDefault();
		setLoading(true);
		setMacroAttSelected(macro);
		if (macro.key === -1) {
			setListaPrestazioniFiltrata(prestazioni);
		} else {
			let attFiltrate = filtraLista(prestazioni, null, macro.key!.toString());
			setListaPrestazioniFiltrata(attFiltrate);
		}
		setModalFilter("");
		setLoading(false);
	};

	const selectAttivita = async (attivita: IOption) => {
		recuperaDescrizione(attivita.value as number);
		setPrestazioneSelected(attivita);
		closeModal();
		cleanModal();
	};

	const [descrizioneAttivita, setDescrizioneAtttivita] = useState<string>("");
	const [mostraDescrizioneAttivita, setMostraDescrizioneAttivita] = useState<boolean>(false);
	const recuperaDescrizione = async (igu: number) => {
		const request: INumericArrayRequest = {
			culture: i18n.language,
			Values: [igu],
		};
		const descrizioni = await PrestazioneRepository.getDescrizionePrestazioni(request);
		if (descrizioni !== undefined) {
			const ds = descrizioni.find((el: IDescrizioneAttivita) => {
				return el.IguAttivita === Number(igu);
			});
			if (ds !== undefined) setDescrizioneAtttivita(ds.DettagliAttivita);
			else setDescrizioneAtttivita("");
		} else setDescrizioneAtttivita("");
	};

	const pressEnterSelectAttivita = (ev: any, attivita: IOption) => {
		// aggiunta $ALC
		ev.preventDefault();
		// recuperaDescrizione(attivita.value as number);
		recuperaDescrizione(attivita.value as number);
		setPrestazioneSelected(attivita);
		closeModal();
		cleanModal();
	};

	const onSelectAttPressEnter = () => {};

	const tornaMacro = () => {
		setLoading(true);
		setListaMacroFiltrata(macroPrestazioni);
		setModalFilter("");
		setMacroAttSelected(undefined);
		setLoading(false);
	};

	const onFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		let originalVal = e.currentTarget.value;
		setModalFilter(originalVal);
		let val = originalVal.toUpperCase();
		if (macroAttSelected && prestazioni) {
			setListaPrestazioniFiltrata(prestazioni.filter((x) => x.label.toUpperCase().includes(val)));
		} else {
			setListaMacroFiltrata(macroPrestazioni.filter((x) => x.label.toUpperCase().includes(val)));
		}
	};

	const closeModal = () => {
		// setDivOpen("prestazione-modal close");
		// setBackdropOpen("backdrop close");
		setShelfOpen(false); //aggiunta $ALC
		mainInputRef.current.focus();
		document.body.classList.remove("noscroll");
	};

	const cleanModal = () => {
		setMacroAttSelected(undefined);
		setListaMacroFiltrata(macroPrestazioni);
		setListaPrestazioniFiltrata(prestazioni);
		setModalFilter("");
	};

	const resetSelection = () => {
		setPrestazioneSelected(undefined);
		setDescrizioneAtttivita("");
	};

	useEffect(() => {
		// aggiunta $ALC
		if (startRef.current) startRef.current.focus();
	}, [dataForm.prestazione]);
	useEffect(() => {
		let attQs = StorageHelper.getItem("default-activity");
		if (attQs) setLoadingAttivitaQs(true);

		let attDataForm: any = null;
		if (dataForm.prestazione) {
			attDataForm = {
				key: dataForm.prestazione.IguAttivita,
				value: dataForm.prestazione.IguAttivita.toString(),
				label: dataForm.prestazione.Attivita,
			};
			setPrestazioneSelected(attDataForm);
		}

		async function getData() {
			setLoading(true);
			let areaRequestProps: IGetPrestazioniRequest = {
				IdEquipe: dataForm.area?.IdEquipe!,
				CodGruppo: dataForm.area?.CodGruppo!,
				culture: i18n.language,
				IdSessione: sessionInfo.sessione?.idSessione,
				step: sessionInfo.step as number,
			};

			areaRequestProps.ActivityOwner = -1;

			let prestsWs = await PrestazioneRepository.getPrestazioni(areaRequestProps);
			let prests: IOptionDetail[] = [];
			if (prestsWs) {
				prests = prestsWs?.map((x) => {
					let p: IOptionDetail = {
						key: x.IguAttivita,
						value: x.IguAttivita.toString(),
						label: x.Attivita,
						masterKey: x.Owner.toString(),
					};
					return p;
				});
			}
			setPrestazioni(prests);
			setListaPrestazioniFiltrata(prests);

			let macro: IOption[] = [];
			let macroWs = await PrestazioneRepository.getMacroPrestazioni();
			if (macroWs && macroWs.length > 0) {
				let dummyMacro: IOption = {
					key: -1,
					label: t("prestazione.lista.tutteLeAttivita"),
					value: "-1",
				};
				macro.push(dummyMacro);

				var macroWsFiltered = macroWs.filter((x) => {
					return prests.find((prest) => {
						return prest.masterKey === x.value.toString();
					});
				});
				macro = macro.concat(macroWsFiltered);
			}

			setMacroPrestazioni(macro);
			setListaMacroFiltrata(macro);

			let macroFiltrate = getActivityOwner(macro);

			if (macroFiltrate && macroFiltrate.length > 0) {
				if (!dataForm.prestazione) {
					// setDivOpen("prestazione-modal");
					setShelfOpen(true); //aggiunta $ALC
				}
				let macroPreselezionata = macroFiltrate[0];
				areaRequestProps.ActivityOwner = macroPreselezionata.key;
				setMacroAttSelected(macroPreselezionata);

				let prestFiltrate = filtraLista(prests, null, macroPreselezionata.key!.toString());
				setListaPrestazioniFiltrata(prestFiltrate);
			}

			if (attQs && !attDataForm) {
				let prestFiltrate = getDefaultActivity(prests);
				if (prestFiltrate && prestFiltrate.length > 0) {
					let prestPreselezionata = prestFiltrate[0];
					setPrestazioneSelected(prestPreselezionata);
				} else {
					setPrestazioneNonErogabile(true);
				}
			}

			setLoadingAttivitaQs(false);
			setLoading(false);
		}
		getData();
	}, [
		sessionInfo.step,
		dataForm.area?.CodGruppo,
		dataForm.area?.IdEquipe,
		dataForm.prestazione,
		getActivityOwner,
		getDefaultActivity,
		sessionInfo.sessione,
		t,
		setPrestazioneNonErogabile,
		setPrestazioneSelected,
	]);

	useEffect(() => {
		if (descrizioneAttivita !== "") {
			if (mostraDescrizioneAttivita && descrizioneRef.current !== undefined) descrizioneRef.current.focus();
			else if (!mostraDescrizioneAttivita && predescrizioneRef.current !== undefined) predescrizioneRef.current.focus();
		}
	}, [descrizioneAttivita, descrizioneRef, mostraDescrizioneAttivita, predescrizioneRef]);

	const listFooterComponent = (
		<>
			<div className="title item ">
				<span>{t("prestazione.lista.nessunRecord.titolo")}</span>
			</div>
			<div className="text item">
				<CustomTranslation t={t} type="phone"  i18Key={"prestazione.lista.nessunRecord.sottotitolo"} />
			</div>
		</>
	);

	return (
		<div id="prestazioneSidebar" role="main" aria-label="Step 3">
			{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
			<div className="title item" tabIndex={0} ref={startRef}>
				<span>{t("prestazione.title")}</span>
			</div>
			<div className="text item">
				<span>{t("prestazione.text.0")}</span>
			</div>

			{prestazioneNonErogabile && (
				<Alert
					type="warning"
					className={"warning-prest-non-erogabile"}
					showIcon
					message={<CustomTranslation t={t} type="phone" i18Key={"prestazione.popup.text"} />}
				/>
			)}

			<CustomShelf open={shelfOpen} onClose={onClickModalClose} ariaLabel={t("scegliPrestazione")}>
				<div className="div-modal-prestazione-input">
					<Input
						ref={chooseActivityRef}
						size="large"
						type="text"
						placeholder={!macroAttSelected ? t("prestazione.lista.filtroPlaceholder.macro") : t("prestazione.lista.filtroPlaceholder.attivita")}
						value={modalFilter}
						onChange={onFilterChange}
						onPressEnter={onSelectAttPressEnter}
						suffix={<FaSearch />}
					/>
				</div>
				<div className="modal-scrollable-div" id="modal-scrollable-div" style={{ height: modalListHeight() }}>
					{!macroAttSelected ? (
						<ConfigProvider renderEmpty={() => <></>}>
							<List
								size="large"
								bordered
								rowKey={(macro) => `${macro.key}`}
								loading={loading}
								dataSource={listaMacroFiltrata}
								renderItem={(macro) => (
									<List.Item
										className={`modal-prestazione-list-item modal-prestazione-list-item-macro ${macro.key === -1 ? "item-tutte-prest" : ""}`}
										tabIndex={0}
										onKeyDownCapture={(ev: any) => {
											pressEnterSelectMacroAtt(ev, macro);
										}}
										onClick={() => selectMacroAtt(macro)}
									>
										<h3>{`${macro.label}`}</h3>
										<Button className="button-transaparent" aria-label="see all">
											<FaChevronRight />
										</Button>
									</List.Item>
								)}
								footer={listFooterComponent}
							/>
						</ConfigProvider>
					) : (
						<ConfigProvider renderEmpty={() => <></>}>
							<List
								size="large"
								bordered
								rowKey={(att) => `${att.key}`}
								loading={loading}
								dataSource={listaPrestazioniFiltrata}
								renderItem={(att) => (
									<List.Item
										className="modal-prestazione-list-item prestazione"
										tabIndex={0}
										onKeyDownCapture={(ev: any) => {
											pressEnterSelectAttivita(ev, att);
										}}
										onClick={() => selectAttivita(att)}
									>
										{`${att.label}`}
									</List.Item>
								)}
								header={
									<>
										<div
											className="ant-list-item modal-prestazione-list-header riepilogo-macro-selezionata"
											onClick={() => tornaMacro()}
											onKeyDown={(event) => {
												if (event.key === "Enter") {
													tornaMacro();
												}
											}}
											role="button"
											tabIndex={-1}
										>
											<Button className="button-transaparent">
												<FaChevronLeft />
											</Button>
											<h3>{`${macroAttSelected?.label}`}</h3>
										</div>
									</>
								}
								footer={listFooterComponent}
							/>
						</ConfigProvider>
					)}
				</div>
			</CustomShelf>

			<Spin spinning={loadingAttivitaQs}>
				<Form onFinish={OnSubmit}>
					<div className="prestazione-find">
						<div className="input-prestazione">
							<Input
								ref={mainInputRef}
								aria-label="choose service"
								size="large"
								readOnly={true}
								type="text"
								onClick={openSelectionModal}
								onPressEnter={openSelectionModal}
								value={prestazioneSelected ? `${prestazioneSelected.label}` : undefined}
								suffix={
									<Button className="svuota-input" aria-label="cancel service" onClick={() => resetSelection()}>
										<FaTimesCircle />
									</Button>
								}
							/>

							{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
							<div className="descrizione-attivita" tabIndex={0} ref={predescrizioneRef}>
								{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
								<FaInfoCircle
									tabIndex={0}
									role="button"
									aria-label="show description"
									className={`icona-info-attivita ${descrizioneAttivita === "" ? "non-disponibile" : ""}`}
									onClick={() => {
										setMostraDescrizioneAttivita(true);
									}}
									onKeyUp={(ev: any) => {
										if (ev.code.toLowerCase() === "enter") setMostraDescrizioneAttivita(true);
									}}
								/>
								<CustomShelf
									open={mostraDescrizioneAttivita}
									onClose={() => {
										setMostraDescrizioneAttivita(false);
									}}
								>
									{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
									<div className="shelf-descrizione-attivita" tabIndex={0} ref={descrizioneRef}>
										<h2>{t("text.descrizione")}</h2>
										{descrizioneAttivita ? (
											<p className="testo-descrizione-attivita" dangerouslySetInnerHTML={{ __html: descrizioneAttivita }}></p>
										) : (
											<p>{t("text.descrizione-assente")}</p>
										)}
									</div>
								</CustomShelf>
							</div>
						</div>
					</div>

					<div className="button-box item">
						<CustomButton text={t("backButton")} OnClick={() => MoveStep("prev")} buttonType={CustomButtonType.negative} />
						<CustomButton
							text={t("prestazione.button")}
							htmlType="submit"
							buttonType={CustomButtonType.positive}
							enabled={prestazioneSelected !== undefined}
						/>
					</div>
				</Form>
			</Spin>
		</div>
	);
};

export default Enhanced(PrestazioneSidebar, { componentNamespace: "PrestazioneSidebar" });
